import { GetPartnerEligibility, IGetPartnerEligibilityRequest, IGetPartnerEligibilityResponse } from '../contracts';
import axios, { AxiosResponse } from 'axios';
import { createAxiosConfig } from '../mockHelper';
import CookieHelper from '../../utils/cookieHelper';
import LogCannon from '@ace-clublabs/log-cannon';

export const GetPartnerEligibilityApi =
  (endpoint: string): GetPartnerEligibility =>
  async (request: IGetPartnerEligibilityRequest) => {
    const scenario = CookieHelper.getCookie('scenario');

    try {
      let response: AxiosResponse<IGetPartnerEligibilityResponse>;
      console.log(`requesting session info for ${request.sessionId}`);
      response = await axios
        .post(endpoint, request, createAxiosConfig(scenario, endpoint))
        .then((response) => response)
        .catch((e) => e.response);

      LogCannon.blast('GetPartnerEligibilityApi success');

      return Promise.resolve(response.data);
    } catch (e) {
      return Promise.reject({ error: e });
    }
  };
